// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import {
  Box,
  Link,
  SpaceBetween,
  TextContent,
} from '@cloudscape-design/components';
import CopyableCodeView from '../CopyableCodeView';
import {
  cdkSingleRegionCode,
  cdkMultiRegionCode,
  cdkDeploymentCode,
} from '../constants';

const CdkDeployStep = () => {
  return (
    <SpaceBetween size="m">
      <Box>
        <TextContent>
          <h3>Single Region Deployment</h3>
          <p>For deploying ResourceLens to a single region (simplest approach):</p>
        </TextContent>
        <CopyableCodeView content={cdkSingleRegionCode} />
      </Box>
      <Box>
        <TextContent>
          <h3>Multi-Region Deployment (Optional)</h3>
          <p>For deploying ResourceLens across multiple regions:</p>
        </TextContent>
        <CopyableCodeView content={cdkMultiRegionCode} />
      </Box>
      <Box>
        <TextContent>
          <h3>Deploy Your Stack</h3>
        </TextContent>
        <CopyableCodeView content={cdkDeploymentCode} />
      </Box>
      <Box>
        <TextContent>
          <h3>Package Information</h3>
          <ul>
            <li>
              <strong>Package URL:</strong>{' '}
              <Link
                external
                href="https://code.amazon.com/packages/ResourceLensCDKConstructs/trees/mainline"
              >
                https://code.amazon.com/packages/ResourceLensCDKConstructs/trees/mainline
              </Link>
            </li>
            <li>
              <strong>Brazil Package:</strong> ResourceLensCDKConstructs
            </li>
            <li>
              <strong>npm Package:</strong> @amzn/resource-lens-constructs
            </li>
          </ul>
        </TextContent>
      </Box>
    </SpaceBetween>
  );
};

export default CdkDeployStep;
